import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[alert-func]',
    standalone: false
})
export class AlertFuncDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}